import { xBaseTheme } from "@guestsupply/XDL/types";

export default {} as xBaseTheme;
